import { Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";

const BoxCodeAssociation = ({ name, code }) => {
  return (
    <Card sx={{ minHeight: 70 }}>
      <CardContent>
        <Stack gap={2}>
          <Typography variant="h6">{name}</Typography>
          <Typography variant="body2" sx={{ alignSelf: "flex-end" }}>
            {code}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default BoxCodeAssociation;
